import { CallApi } from "./ApiCommon";
import { ApiRequestError } from "./ApiRequestError";

export const PostLogin = async (mail: string, pass: string) => {
  try {
    // localhost環境判定（開発環境でlocalhostの場合）
    const isLocalhost = window.location.hostname === "localhost";

    const body: Record<string, unknown> = {
      mail: mail,
      pass: pass,
    };
    if (isLocalhost) {
      body.is_localhost = true;
    }

    const result = await CallApi(
      "/api_user/authentication",
      {
        credentials: "include",
        method: "POST",
        body: JSON.stringify(body),
      },
      false
    );

    return result.redirect_to as string;
  } catch (e: any) {
    if (e instanceof ApiRequestError) throw e;
    throw new ApiRequestError(e.message);
  }
};

export const GetLoginStatus = async () => {
  try {
    const result = await CallApi(
      "/api_user/login_status",
      {
        credentials: "include",
        method: "GET",
      },
      false
    );

    return {
      loggedIn: result.logged_in as boolean,
      redirectTo: result.redirect_to as string,
    };
  } catch (e: any) {
    if (e instanceof ApiRequestError) throw e;
    throw new ApiRequestError(e.message);
  }
};
